import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AddressBookResolver,
  AddressResolver,
  AuctionBidsResolver,
  AuctionResolver,
  AuthGuard,
  BalanceResolver,
  BenefitResolver,
  CardTokenResolver,
  CountryResolver,
  FantasyGameResolver,
  FantasyHistoryResolver,
  GameDataSource,
  // RegistrationStepResolver,
  LottoWalletResolver,
  MaintenanceGuard,
  MemberCardResolver,
  MemberLoyaltyStatusResolver,
  // StepType,
  MemberResolver,
  PartnerPendingResolver,
  PartnerResolver,
  PopUpNotificationResolver,
  // TicketTransferGuard,
  PortalProductsSubscriptionsResolver,
  PreviewResolver,
  ProviderName,
  PurchaseResolver,
  SeatingDetailResolver,
  SurveyResolver,
  TicketResolver,
  TransactionSuccessGuard,
  accountVerificationGuard,
  // FGBPreLoadingStrategy,
  firstTimeUserGuard,
  gameWithTicketResolver,
  ticketTransferGuard,
} from '@fgb/core';

// General
import { ContactUsPageComponent } from './pages/contact-us-page/contact-us-page.component';
import { FaqPageComponent } from './pages/faq-page/faq-page.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { MasterPageComponent } from './pages/master/master-page/master-page.component';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { TermsPageComponent } from './pages/terms-page/terms-page.component';
// Loyalty
import { AuctionDetailPageComponent } from './pages/auction-detail-page/auction-detail-page.component';
import { AuctionWalletDetailsPageComponent } from './pages/auction-wallet-details-page/auction-wallet-details-page.component';
import { AuctionsPageComponent } from './pages/auctions-page/auctions-page.component';
import { BadgesPageComponent } from './pages/badges-page/badges-page.component';
import { EventsPageComponent } from './pages/events-page/events-page.component';
import {
  FantasyGamesPageComponent,
  FantasyGamesPlayPageComponent,
} from './pages/fantasy-games-page/fantasy-games-page.component';
import { FantasyPlayerSelectPageComponent } from './pages/fantasy-player-select-page/fantasy-player-select-page.component';
import { GamesLayoutComponent } from './pages/games-layout/games-layout.component';
import { GamesPageComponent } from './pages/games-page/games-page.component';
import { JokesPageComponent } from './pages/jokes-page/jokes-page.component';
import { LottoDetailPageComponent } from './pages/lotto-detail-page/lotto-detail-page.component';
import { LottoWalletDetailsPageComponent } from './pages/lotto-wallet-details-page/lotto-wallet-details-page.component';
import { LottosPageComponent } from './pages/lottos-page/lottos-page.component';
import { LottosSuccessPageComponent } from './pages/lottos-page/lottos-success-page/lottos-success-page.component';
import { MarketplaceDetailPageComponent } from './pages/marketplace-detail-page/marketplace-detail-page.component';
import { MarketplacePageComponent } from './pages/marketplace-page/marketplace-page.component';
import { MarketplacePurchaseSuccessPageComponent } from './pages/marketplace-page/marketplace-purchase-success-page/marketplace-purchase-success-page.component';
import { ProductsPageComponent } from './pages/products-page/products-page.component';
import { QuizPageComponent } from './pages/quiz-page/quiz-page.component';
import { RewardsLayoutComponent } from './pages/rewards-layout/rewards-layout.component';
import { WalletPageComponent } from './pages/wallet-page/wallet-page.component';

// Account
import { AccountDetailsPageComponent } from './pages/account-details-page/account-details-page.component';
import { EditQuestionsPageComponent } from './pages/edit-questions-page/edit-questions-page.component';
import { ActivityPageComponent } from './pages/activity-page/activity-page.component';
import { FacialIdPageComponent } from './pages/facial-id-page/facial-id-page.component';
import { RepresentativePageComponent } from './pages/representative-page/representative-page.component';
import { MembershipPageComponent } from './pages/membership-page/membership-page.component';
import { CardPageComponent } from './pages/card-page/card-page.component';
import { GuardianPageComponent } from './pages/guardian-page/guardian-page.component';
// Ecash
import { EcashHistoryPageComponent } from './pages/ecash-history/ecash-history.component';
import { EcashFailurePageComponent } from './pages/ecash-page/ecash-failure-page/ecash-failure-page.component';
import { EcashPageComponent } from './pages/ecash-page/ecash-page.component';
import { EcashResultPageComponent } from './pages/ecash-page/ecash-result-page/ecash-result-page.component';
import { EcashSuccessPageComponent } from './pages/ecash-page/ecash-success-page/ecash-success-page.component';
// Portal Products
import { PortalProductFailurePageComponent } from './pages/portal-products-pages/portal-product-failure-page/portal-product-failure-page.component';
import { PortalProductResultsPageComponent } from './pages/portal-products-pages/portal-product-results-page/portal-product-results-page.component';
import { PortalProductSuccessPageComponent } from './pages/portal-products-pages/portal-product-success-page/portal-product-success-page.component';
// Events & Tickets
import { ContactsPageComponent } from './pages/contacts-page/contacts-page.component';
import { ManageTicketHistoryPageComponent } from './pages/manage-ticket-history-page/manage-ticket-history-page.component';
import { ManageTicketsPageComponent } from './pages/manage-tickets-page/manage-tickets-page.component';
import { TicketTransferPageComponent } from './pages/ticket-transfer-page/ticket-transfer-page.component';
import { TicketTransferSuccessPageComponent } from './pages/ticket-transfer-page/ticket-transfer-success-page/ticket-transfer-success-page.component';
import { TicketsPageComponent } from './pages/ticket-transfer-page/tickets-page/tickets-page.component';
import { TransferConfirmPageComponent } from './pages/ticket-transfer-page/transfer-confirm-page/transfer-confirm-page.component';
// Cash Transfer
import { TransferArenaCashPageComponent } from './pages/transfer-arena-cash-page/transfer-arena-cash-page.component';
import { TransferArenaCashSuccessPageComponent } from './pages/transfer-arena-cash-success-page/transfer-arena-cash-success-page.component';
import { TransferMultipleAccountsPageComponent } from './pages/transfer-multiple-accounts-page/transfer-multiple-accounts-page.component';
// Unauthenticated
import { AuthCallbackComponent } from './modules/user/components/auth/auth-callback/auth-callback.component';
import { SingleSignOnComponent } from './modules/user/components/single-sign-on/single-sign-on.component';
import { LoginAccountsPageComponent } from './pages/login-accounts-page/login-accounts-page.component';
import { MlbamAccountSelectionComponent } from './modules/user/components/mlbam-account-selection/mlbam-account-selection.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { MaintenancePageComponent } from './pages/maintenance-page/maintenance-page.component';
// Registration
// import { RegistrationPaymentComponent } from './modules/registration/pages/steps/registration-payment/registration-payment.component';
// Population Pages
// Club Pages
import { BenefitsPageComponent } from './pages/benefits-page/benefits-page.component';
import { EarnPageComponent } from './pages/earn-page/earn-page.component';
import { PointsManagementPageComponent } from './pages/points-management-page/points-management-page.component';
import { TailgatePageComponent } from './pages/tailgate-page/tailgate-page.component';

// Partners Pages
import { V1SingleSignOnComponent } from './modules/user/components/v1-single-sign-on/v1-single-sign-on.component';
import { CartCheckoutPagePortalProductsComponent } from './pages/cart-checkout-page-portal-products/cart-checkout-page-portal-products.component';
import { CartCheckoutPageComponent } from './pages/cart-checkout-page/cart-checkout-page.component';
import { FantasyLeaderboardPageComponent } from './pages/fantasy-leaderboard-page/fantasy-leaderboard-page.component';
import { LeaderboardPageComponent } from './pages/leaderboard-page/leaderboard-page.component';
import { LottosTermsPageComponent } from './pages/lottos-terms-page/lottos-terms-page.component';
import { MarketplaceTermsPageComponent } from './pages/marketplace-terms-page/marketplace-terms-page.component';
import { PartnerPageComponent } from './pages/partner-page/partner-page.component';
import { RenewalBonusTransferPageComponent } from './pages/renewal-bonus-transfer-page/renewal-bonus-transfer-page.component';
import { SubscriptionsPageComponent } from './pages/subscriptions-page/subscriptions-page.component';
import { WorksheetPageComponent } from './pages/worksheet-page/worksheet-page.component';
import { ZoomMeetingPageComponent } from './pages/zoom-meeting-page/zoom-meeting-page.component';
import { TmCallbackComponent } from './shared/components/manage-tickets/tm-callback/tm-callback.component';
import { TmAuthCallbackComponent } from './shared/components/providers/tm/tm-auth-callback/tm-auth-callback.component';
// Offer Pages
import { ScorecardDescriptionComponent } from '@fgb/portal-component-library/src/lib/loyalty/scorecards';
// Partner Offers Pages
import { PartnerOffersPageComponent } from './pages/partner-offers-page/partner-offers-page.component';
import { PartnerOffersDetailPageComponent } from './pages/partner-offers-page/partner-offers-detail-page/partner-offers-detail-page.component';
import { provideRegistrationConfig } from '@fgb/portal-component-library/src/lib/registration';
import { AccountVerifiedPageComponent } from 'src/app/pages/account-activation/account-verified-page/account-verified-page.component';
import { ActivateAccountPageComponent } from 'src/app/pages/account-activation/activate-account-page/activate-account-page.component';
import { FeedsPageComponent } from 'src/app/pages/feeds-page/feeds-page/feeds-page.component';
import { FantasyGameRulesComponent } from './modules/fantasy/components/fantasy-game-rules/fantasy-game-rules.component';
import { RegistrationLayoutPageComponent } from './modules/registration/pages/registration-layout-page/registration-layout-page.component';
import { UserChangePasswordComponent } from './modules/user/components/user-change-password/user-change-password.component';
import { UserResetPasswordComponent } from './modules/user/components/user-reset-password/user-reset-password.component';
import { CampaignDetailsPageComponent } from './pages/campaign-details-page/campaign-details-page.component';
import { CardLinkActivatedOffersPageComponent } from './pages/card-link-activated-offers-page/card-link-activated-offers-page.component';
import { CardLinkAffiliatesPageComponent } from './pages/card-link-affiliates-page/card-link-affiliates-page.component';
import { CardLinkAllOffersPageComponent } from './pages/card-link-all-offers-page/card-link-all-offers-page.component';
import { CardLinkOfferDetailsPageComponent } from './pages/card-link-offer-details-page/card-link-offer-details-page.component';
import { CardLinkingPageComponent } from './pages/card-linking-page/card-linking-page.component';
import { CardLinkingSuccessPageComponent } from './pages/card-linking-success-page/card-linking-success-page.component';
import { CartCheckoutResultsPageComponent } from './pages/cart-checkout-page/cart-checkout-results-page/cart-checkout-results-page.component';
import { CartCheckoutSuccessPageComponent } from './pages/cart-checkout-page/cart-checkout-success-page/cart-checkout-success-page.component';
import { FacialRecognitionUploadPageComponent } from './pages/facial-recognition-upload-page/facial-recognition-upload-page.component';
import { FitnessTrackerPageComponent } from './pages/fitness-tracker-page/fitness-tracker-page.component';
import { GamesV2LayoutComponent } from './pages/games-v2-layout/games-v2-layout.component';
import { KidsLinkedPageComponent } from './pages/kids-linked-page/kids-linked-page.component';
import { MarketplaceTransferSuccessPageComponent } from './pages/marketplace-transfer-success-page/marketplace-transfer-success-page.component';
import { MarketplaceWalletPageComponent } from './pages/marketplace-wallet-page/marketplace-wallet-page.component';
import { NotificationManagementPageComponent } from './pages/notification-management-page/notification-management-page.component';
import { OfferDetailsPageComponent } from './pages/offer-details-page/offer-details-page.component';
import { OffersPageComponent } from './pages/offers-page/offers-page.component';
import { OutsidePortalGamePageComponent } from './pages/outside-portal-game-page/outside-portal-game-page.component';
import { PaymentPageComponent } from './pages/payment-page/payment-page.component';
import { PollsV2PageComponent } from './pages/polls-v2-page/polls-v2-page.component';
import { PredictorV2LeaderboardPageComponent } from './pages/predictor-v2-leaderboard-page/predictor-v2-leaderboard-page.component';
import { PredictorV2PageComponent, PredictorV2PlayComponent } from './pages/predictor-v2-page/predictor-v2-page.component';
import { ReferAFriendPageComponent } from './pages/refer-a-friend-page/refer-a-friend-page.component';
import { SavingsPageComponent } from './pages/savings-page/savings-page.component';
import { SplitTransactionPageComponent } from './pages/split-transaction-page/split-transaction-page.component';
import { TicketInvitePageComponentComponent } from './pages/ticket-invite-page-component/ticket-invite-page-component.component';
import { TierLevelPageComponent } from './pages/tier-level-page/tier-level-page.component';
import { TriviaV2LeaderboardPageComponent } from './pages/trivia-v2-leaderboard-page/trivia-v2-leaderboard-page.component';
import { TriviaV2PageComponent, TriviaV2PlayComponent } from './pages/trivia-v2-page/trivia-v2-page.component';
import { WalletClaimedPageComponent } from './pages/wallet-claimed-page/wallet-claimed-page.component';
import { KeyCloakCallbackComponent } from './shared/components/providers/key-cloak/key-cloak-callback/key-cloak-callback.component';
import { NbaCallbackComponent } from './shared/components/providers/nba/nba-callback/nba-callback.component';
import { OtherMediaCallbackComponent } from './shared/components/providers/other-media/other-media-callback/other-media-callback.component';
import { ProviderCallbackComponent } from './shared/components/providers/provider-callback/provider-callback.component';
import { SalesForceCallbackComponent } from './shared/components/providers/sales-force/sales-force-callback/sales-force-callback.component';
import { SeatGeekCallbackComponent } from './shared/components/providers/seatgeek/seatgeek-callback/seatgeek-callback.component';
import { SportsAllianceCallbackComponent } from './shared/components/providers/sports-alliance/sports-alliance-callback/sports-alliance-callback.component';
import { FitnessTrackerCallbackComponent } from './shared/components/providers/fitness-tracker-callback/fitness-tracker-callback.component';
import { CampaignV2DetailsOfferPageComponent } from './pages/campaign-v2-details-offer-page/campaign-v2-details-offer-page.component';
import { CampaignV2DetailsVoucherPageComponent } from './pages/campaign-v2-details-voucher-page/campaign-v2-details-voucher-page.component';
import { FantasyUpNextV2Component } from './modules/fantasy/components/fantasy-up-next-v2/fantasy-up-next-v2.component';
import { FantasyGameRulesV2Component } from './modules/fantasy/components/fantasy-game-rules-v2/fantasy-game-rules-v2.component';
import { FantasyLeaderboardV2Component } from './modules/fantasy/components/fantasy-leaderboard-v2/fantasy-leaderboard-v2.component';
import { FantasyGameResultsComponent } from './modules/fantasy/components/fantasy-game-results/fantasy-game-results.component';
import { FantasyGamePlayV2Component } from './modules/fantasy/components/fantasy-game-play-v2/fantasy-game-play-v2.component';
import { UnifiedCheckoutPageComponent } from './pages/unified-checkout-page/unified-checkout-page.component';
import { layoutConfig } from '@fgb/portal-component-library/src/lib/shared/services';
import { UnifiedCheckoutSuccessPageComponent } from './pages/unified-checkout-page/unified-checkout-success-page/unified-checkout-success-page.component';
import { UnifiedCheckoutFailurePageComponent } from './pages/unified-checkout-page/unified-checkout-failure-page/unified-checkout-failure-page.component';
import { UnifiedCheckoutResultsPageComponent } from './pages/unified-checkout-page/unified-checkout-results-page/unified-checkout-results-page.component';
import { MemberNetworkPageComponent } from './pages/member-network-page/member-network-page.component';
import { ScorecardsV2PageComponent } from './pages/scorecards-v2-page/scorecards-v2-page.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard, firstTimeUserGuard(), accountVerificationGuard('/activate')],
    canActivateChild: [MaintenanceGuard],
    component: MasterPageComponent,
    resolve: {
      member: MemberResolver,
      memberCard: MemberCardResolver,
      balances: BalanceResolver,
      popupNotifications: PopUpNotificationResolver,
    },
    children: [
      {
        path: '',
        resolve: { CardTokenResolver },
        component: HomePageComponent,
      },
      {
        path: 'link-child',
        component: KidsLinkedPageComponent,
        resolve: {
          country: CountryResolver,
          address: AddressResolver,
        },
      },
      {
        path: 'guardians',
        component: GuardianPageComponent,
        resolve: {
          country: CountryResolver,
          address: AddressResolver,
        },
      },

      {
        path: 'cards',
        component: CardPageComponent,
      },

      {
        path: 'worksheet',
        component: WorksheetPageComponent,
      },
      {
        path: 'rewards',
        component: RewardsLayoutComponent,
        children: [
          {
            path: '',
            redirectTo: 'marketplace',
            pathMatch: 'full',
          },
          {
            path: 'auctions',
            children: [
              {
                path: '',
                resolve: { auctions: AuctionResolver },
                component: AuctionsPageComponent,
              },
              {
                path: 'details/:id',
                resolve: {
                  balances: BalanceResolver,
                  auctions: AuctionResolver,
                },
                component: AuctionDetailPageComponent,
              },
            ],
          },
          {
            path: 'marketplace',
            children: [
              {
                path: '',
                component: MarketplacePageComponent,
              },
              {
                path: 'details/:id',
                children: [
                  {
                    path: '',
                    resolve: {
                      balances: BalanceResolver,
                      cardTokens: CardTokenResolver,
                      country: CountryResolver,
                    },
                    component: MarketplaceDetailPageComponent,
                  },
                  {
                    path: 'terms',
                    component: MarketplaceTermsPageComponent,
                  },
                ],
              },
              {
                path: 'purchase/success',
                component: MarketplacePurchaseSuccessPageComponent,
                resolve: {
                  balances: BalanceResolver,
                },
              },
            ],
          },
          {
            path: 'events',
            component: EventsPageComponent,
          },
          {
            path: 'products',
            component: ProductsPageComponent,
          },
          {
            path: 'raffles',
            children: [
              {
                path: '',
                component: LottosPageComponent,
                resolve: { balances: BalanceResolver },
              },
              {
                path: 'details/:id',
                children: [
                  {
                    path: '',
                    resolve: { balances: BalanceResolver },
                    component: LottoDetailPageComponent,
                  },
                  {
                    path: 'terms',
                    component: LottosTermsPageComponent,
                  },
                ],
              },
              {
                path: 'purchase/success',
                canActivate: [TransactionSuccessGuard],
                component: LottosSuccessPageComponent,
              },
            ],
          },
          {
            path: 'wallet',
            children: [
              {
                path: '',
                component: WalletPageComponent,
              },
              {
                path: 'details/:id',
                component: MarketplaceWalletPageComponent,
                resolve: { purchases: PurchaseResolver },
              },
              {
                path: 'raffledetails/:id',
                component: LottoWalletDetailsPageComponent,
                resolve: { lottoWalletItems: LottoWalletResolver },
              },
              {
                path: 'transfer/success',
                component: MarketplaceTransferSuccessPageComponent,
              },
            ],
            resolve: { partners: PartnerResolver },
          },
          {
            path: 'claimed',
            children: [
              {
                path: '',
                component: WalletClaimedPageComponent,
                resolve: {
                  purchases: PurchaseResolver,
                  lottoWalletItems: LottoWalletResolver,
                  auctionBids: AuctionBidsResolver,
                },
              },
            ],
          },
          {
            path: 'bids',
            children: [
              {
                path: 'details/:id',
                component: AuctionWalletDetailsPageComponent,
                resolve: { bids: AuctionBidsResolver },
              },
            ],
          },
        ],
      },
      {
        path: 'account',
        component: AccountDetailsPageComponent,
        resolve: {
          cardTokens: CardTokenResolver,
          member: MemberResolver,
          balances: BalanceResolver,
          seating: SeatingDetailResolver,
          memberLoyaltyStatus: MemberLoyaltyStatusResolver,
        },
      },
      {
        path: 'member-network',
        component: MemberNetworkPageComponent,
      },
      {
        path: 'profile',
        component: AccountDetailsPageComponent,
        data: { isProfilePage: true, titleKey: 'account.profile.title', titleDefault: 'Profile' },
        resolve: {
          cardTokens: CardTokenResolver,
          member: MemberResolver,
          balances: BalanceResolver,
          seating: SeatingDetailResolver,
          memberLoyaltyStatus: MemberLoyaltyStatusResolver,
        },
      },
      { path: 'activity', component: ActivityPageComponent },
      { path: 'splitTransactions', component: SplitTransactionPageComponent },
      { path: 'pointsmanagement', component: PointsManagementPageComponent, resolve: { partners: PartnerResolver } },
      {
        path: 'partners',
        component: PartnerPageComponent,
        resolve: { partners: PartnerResolver, pendingPartners: PartnerPendingResolver },
      },
      { path: 'edit-questions', component: EditQuestionsPageComponent },
      { path: 'facial-id', component: FacialIdPageComponent },
      { path: 'representative', component: RepresentativePageComponent },
      {
        path: 'membership',
        component: MembershipPageComponent,
        resolve: { memberLoyaltyStatus: MemberLoyaltyStatusResolver },
      },
      {
        path: 'payment',
        resolve: { balances: BalanceResolver, cardTokens: CardTokenResolver },
        children: [
          { path: '', component: PaymentPageComponent },
          {
            path: 'card',
            component: UnifiedCheckoutPageComponent,
            data: layoutConfig({ footer: false, mobileNavbar: false }, { mode: 'add-card' }),
          },
          {
            path: 'checkout',
            component: UnifiedCheckoutPageComponent,
            data: layoutConfig({ footer: false, mobileNavbar: false }, { mode: 'checkout' }),
          },
          {
            path: 'checkout/results',
            component: UnifiedCheckoutResultsPageComponent,
          },
          {
            path: 'checkout/success',
            component: UnifiedCheckoutSuccessPageComponent,
          },
          {
            path: 'checkout/failure',
            component: UnifiedCheckoutFailurePageComponent,
          },
        ],
      },
      {
        path: 'ecash',
        resolve: { balances: BalanceResolver, cardTokens: CardTokenResolver },
        children: [
          { path: '', component: EcashPageComponent },
          {
            path: 'success',
            resolve: { balances: BalanceResolver },
            component: EcashSuccessPageComponent,
          },
          { path: 'failure', component: EcashFailurePageComponent },
          { path: 'result', component: EcashResultPageComponent },
          {
            path: 'bonustransfer',
            resolve: {
              partners: PartnerResolver,
              balances: BalanceResolver,
            },
            component: RenewalBonusTransferPageComponent,
          },
        ],
      },
      {
        path: 'ecashhistory',
        resolve: {
          balances: BalanceResolver,
          cardTokens: CardTokenResolver,
          memberCard: MemberCardResolver,
          member: MemberResolver,
        },
        component: EcashHistoryPageComponent,
      },
      {
        path: 'portalproducts',
        resolve: { balances: BalanceResolver, cardTokens: CardTokenResolver },
        children: [
          {
            path: 'success',
            resolve: { balances: BalanceResolver },
            component: PortalProductSuccessPageComponent,
          },
          { path: 'failure', component: PortalProductFailurePageComponent },
          { path: 'result', component: PortalProductResultsPageComponent },
        ],
      },
      {
        path: 'cardtoken',
        children: [
          { path: 'success', component: EcashSuccessPageComponent },
          { path: 'failure', component: EcashFailurePageComponent },
          { path: 'result', component: EcashResultPageComponent },
        ],
      },
      {
        path: 'offers',
        children: [
          { path: '', component: OffersPageComponent },
          {
            path: 'details/:offerId',
            component: OfferDetailsPageComponent,
          },
        ],
      },
      {
        path: 'savings',
        children: [{ path: '', component: SavingsPageComponent }],
      },
      {
        path: 'campaign',
        children: [
          {
            path: 'details/:offerId',
            component: CampaignDetailsPageComponent,
          },
        ],
      },
      {
        path: 'campaign-v2',
        children: [
          {
            path: 'details/offer/:offerId',
            component: CampaignV2DetailsOfferPageComponent,
          },
          {
            path: 'details/voucher/:voucherId',
            component: CampaignV2DetailsVoucherPageComponent,
          },
        ],
      },
      { path: 'faq', component: FaqPageComponent },
      { path: 'terms', component: TermsPageComponent },
      { path: 'contact', component: ContactUsPageComponent },
      { path: 'referral', component: ReferAFriendPageComponent },
      { path: 'referafriend', component: ReferAFriendPageComponent },
      { path: 'challenges', component: BadgesPageComponent },
      { path: 'challenges-v2', component: ScorecardsV2PageComponent },
      { path: 'facial-recognition', component: FacialRecognitionUploadPageComponent },
      { path: 'scorecard-description/:id', component: ScorecardDescriptionComponent },
      {
        path: 'ticketTransfer',
        children: [
          {
            path: '',
            component: TicketTransferPageComponent,
            resolve: {
              ticketResolver: TicketResolver,
            },
          },
          {
            path: 'tickets/:gameNumber',
            children: [
              {
                path: '',
                component: TicketsPageComponent,
              },
              {
                path: 'transfer',
                component: TransferConfirmPageComponent,
                resolve: { addressBookResolver: AddressBookResolver },
                canActivate: [ticketTransferGuard()],
              },
            ],
            resolve: {
              ticketResolver: TicketResolver,
            },
          },
          { path: 'success', component: TicketTransferSuccessPageComponent },
        ],
        resolve: {
          gameWithTickets: gameWithTicketResolver(),
        },
      },
      {
        path: 'contacts',
        component: ContactsPageComponent,
        resolve: { addressBookResolver: AddressBookResolver },
      },
      {
        path: 'games',
        resolve: {
          surveys: SurveyResolver,
          games: FantasyGameResolver,
        },
        component: GamesLayoutComponent,
        children: [
          { path: '', component: GamesPageComponent },
          { path: 'quiz', component: QuizPageComponent },
          { path: 'jokes', component: JokesPageComponent },
          { path: 'trivia', component: TriviaV2PageComponent },
          { path: 'predictor', component: PredictorV2PageComponent },
          { path: 'poll', component: PollsV2PageComponent },
          {
            path: 'pickaplayer',
            component: FantasyGamesPageComponent,
            resolve: { games: FantasyGameResolver, history: FantasyHistoryResolver },
            children: [
              { path: '', component: FantasyGamesPlayPageComponent },
              { path: 'play-v2', component: FantasyGamePlayV2Component },
              { path: 'how-to-play', component: FantasyGameRulesComponent },
              { path: 'leaderboard-v2', component: FantasyLeaderboardPageComponent },
              { path: 'leaderboard', component: FantasyLeaderboardV2Component },
              { path: 'up-next', component: FantasyUpNextV2Component },
              { path: 'rules', component: FantasyGameRulesV2Component },
              { path: 'results', component: FantasyGameResultsComponent },
            ],
          },
          {
            path: 'pickaplayer/:id',
            component: FantasyPlayerSelectPageComponent,
            resolve: { games: FantasyGameResolver },
          },
        ],
      },
      {
        path: 'games-v2',
        resolve: {
          games: FantasyGameResolver,
        },
        component: GamesV2LayoutComponent,
        children: [
          { path: '', component: GamesPageComponent },
          {
            path: 'trivia',
            component: TriviaV2PageComponent,
            children: [
              { path: '', component: TriviaV2PlayComponent },
              { path: 'leaderboard-v2', component: TriviaV2LeaderboardPageComponent },
            ],
          },
          { path: 'polls', component: PollsV2PageComponent },
          {
            path: 'predictor',
            component: PredictorV2PageComponent,
            children: [
              { path: '', component: PredictorV2PlayComponent },
              { path: 'leaderboard-v2', component: PredictorV2LeaderboardPageComponent },
            ],
          },
          {
            path: 'pickaplayer',
            component: FantasyGamesPageComponent,
            resolve: { games: FantasyGameResolver, history: FantasyHistoryResolver },
            children: [
              { path: '', component: FantasyGamesPlayPageComponent },
              { path: 'play-v2', component: FantasyGamePlayV2Component },
              { path: 'how-to-play', component: FantasyGameRulesComponent },
              { path: 'leaderboard-v2', component: FantasyLeaderboardPageComponent },
              { path: 'leaderboard', component: FantasyLeaderboardV2Component },
              { path: 'up-next', component: FantasyUpNextV2Component },
              { path: 'rules', component: FantasyGameRulesV2Component },
              { path: 'results', component: FantasyGameResultsComponent },
            ],
          },
          {
            path: 'pickaplayer/:id',
            component: FantasyPlayerSelectPageComponent,
            resolve: { games: FantasyGameResolver },
          },
        ],
      },
      {
        path: 'managetickets',
        children: [
          { path: '', component: ManageTicketsPageComponent },
          { path: ':id', component: ManageTicketsPageComponent },
        ],
      },
      {
        path: 'manageticketshistory',
        component: ManageTicketHistoryPageComponent,
      },
      // Club Pages
      {
        path: 'checkout',
        children: [
          {
            path: '',
            component: CartCheckoutPageComponent,
            resolve: {
              member: MemberResolver,
              address: AddressResolver,
              country: CountryResolver,
            },
          },
          {
            path: 'success',
            component: CartCheckoutSuccessPageComponent,
          },
          {
            path: 'results',
            component: CartCheckoutResultsPageComponent,
          },
        ],
        resolve: {
          address: AddressResolver,
        },
      },
      {
        path: 'watch',
        component: TailgatePageComponent,
        data: {
          gameType: GameDataSource.ExternalRef,
        },
        resolve: {
          surveys: SurveyResolver,
        },
      },
      {
        path: 'subscriptions',
        children: [
          {
            path: '',
            component: SubscriptionsPageComponent,
            resolve: {
              subscriptions: PortalProductsSubscriptionsResolver,
              address: AddressResolver,
            },
          },
          {
            path: 'checkout',
            component: CartCheckoutPagePortalProductsComponent,
            resolve: {
              subscriptions: PortalProductsSubscriptionsResolver,
              address: AddressResolver,
              country: CountryResolver,
              member: MemberResolver,
            },
          },
        ],
      },
      { path: 'notificationmanagement', component: NotificationManagementPageComponent },
      { path: 'earn', component: EarnPageComponent },
      {
        path: 'benefits',
        component: BenefitsPageComponent,
        resolve: { benefits: BenefitResolver },
      },
      {
        path: 'leaderboard',
        component: LeaderboardPageComponent,
      },
      {
        path: 'fantasyleaderboard',
        component: FantasyLeaderboardPageComponent,
      },
      {
        path: 'arenacashtransfer',
        children: [
          {
            path: '',
            component: TransferArenaCashPageComponent,
            resolve: { balances: BalanceResolver },
          },
          {
            path: 'multipleaccounts',
            component: TransferMultipleAccountsPageComponent,
          },
          {
            path: 'success',
            component: TransferArenaCashSuccessPageComponent,
            resolve: { balances: BalanceResolver },
          },
        ],
      },
      { path: '404page', component: NotFoundPageComponent },
      { path: 'signin-ticketmaster', component: TmCallbackComponent },
      {
        path: 'provider/:providerid',
        component: ProviderCallbackComponent,
      },
      // Link Card
      {
        path: 'linkcard',
        children: [{ path: '', component: CardLinkingPageComponent }],
      },

      //Link Card Success
      {
        path: 'linkcardSuccess',
        children: [{ path: '', component: CardLinkingSuccessPageComponent }],
      },
      {
        path: 'affiliate',
        component: CardLinkAffiliatesPageComponent,
        children: [
          { path: 'alloffers', component: CardLinkAllOffersPageComponent },
          { path: 'myoffers', component: CardLinkActivatedOffersPageComponent },
          { path: '', pathMatch: 'full', redirectTo: 'alloffers' },
        ],
      },
      //card linking offer detail
      {
        path: 'offerdetail/:id',
        component: CardLinkOfferDetailsPageComponent,
      },
      { path: 'feed', component: FeedsPageComponent },
      { path: 'tier', component: TierLevelPageComponent },
      { path: 'fitness-tracker', component: FitnessTrackerPageComponent },
      {
        path: 'partner-offers',
        children: [
          { path: '', component: PartnerOffersPageComponent },
          { path: 'details/:id', component: PartnerOffersDetailPageComponent },
        ],
      },
    ],
  },
  {
    path: 'ticketinvite',
    component: TicketInvitePageComponentComponent,
  },
  {
    path: 'zoom/:purchaseId',
    component: ZoomMeetingPageComponent,
    resolve: { member: MemberResolver, purchases: PurchaseResolver },
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginPageComponent, resolve: { preview: PreviewResolver }, canActivate: [MaintenanceGuard] },
  { path: 'login/accounts', component: LoginAccountsPageComponent, canActivate: [MaintenanceGuard] },
  { path: 'login/mlbam', component: MlbamAccountSelectionComponent, canActivate: [MaintenanceGuard] },
  { path: 'reset-password', component: UserResetPasswordComponent },
  { path: 'change-password', component: UserChangePasswordComponent },
  { path: 'facialsinglepage', component: FacialRecognitionUploadPageComponent },
  { path: 'outside-portal-game/:externalUrl', component: OutsidePortalGamePageComponent },
  // {
  //   path: 'register',
  //   canActivateChild: [MaintenanceGuard],
  //   resolve: { registrationStep: RegistrationStepResolver, country: CountryResolver },
  //   children: [
  //     {
  //       path: 'payment',
  //       children: [
  //         {
  //           path: '',
  //           component: RegistrationPaymentComponent,
  //           data: { registrationStep: StepType.Payment },
  //           resolve: { member: MemberResolver, address: AddressResolver },
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    path: 'register',
    component: RegistrationLayoutPageComponent,
    loadChildren: () => import('@fgb/portal-component-library/src/lib/registration').then((m) => m.RegistrationModule),
    providers: [
      provideRegistrationConfig({
        routes: [
          // @Example: Adding child limit manually, temporary changing the child limit for new users. Remove this once the child limit setting feature is implemented.
          // Can remove this if user is not registering as new user adding children
          // @Updated: if settings in admin wizard is set to zero you can use this value to override the child limit in the registration add children, if not
          // it will take the value from the wizard settings.
          {
            path: 'children',
            data: { childLimit: 5 },
          },
          {
            path: 'payment',
            data: {
              showExpressCheckout: true,
              expressCheckoutProviders: [ProviderName.FreedomPay, ProviderName.Paze, ProviderName.PayPal],
            },
          },
        ],
      }),
    ],
  },
  { path: 'VerifyAccount', component: AccountVerifiedPageComponent },
  { path: 'activate', component: ActivateAccountPageComponent },
  { path: 'callback', component: AuthCallbackComponent },
  { path: 'sso', component: SingleSignOnComponent },
  { path: 'login/singleSignOn/:providerId', component: SingleSignOnComponent },
  { path: 'login/singleSignOn/:providerId/:clubId', component: SingleSignOnComponent },
  { path: 'login/ss/login.aspx', component: V1SingleSignOnComponent },
  { path: 'maintenance', component: MaintenancePageComponent },
  { path: 'tm-auth-callback', component: TmAuthCallbackComponent },
  { path: 'sa-callback', component: SportsAllianceCallbackComponent },
  { path: 'kc-callback', component: KeyCloakCallbackComponent },
  { path: 'om-callback', component: OtherMediaCallbackComponent },
  { path: 'sg-callback', component: SeatGeekCallbackComponent },
  { path: 'nba-callback', component: NbaCallbackComponent },
  { path: 'sf-callback', component: SalesForceCallbackComponent },
  { path: 'provider/:providerId/connect-callback', component: FitnessTrackerCallbackComponent },
  { path: '**', redirectTo: '404page' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      // preloadingStrategy: FGBPreLoadingStrategy,
      bindToComponentInputs: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
